import styled from 'astroturf/react';

const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: 20px 40px;

  [class*='button-wrapper'] {
    width: 130px;
    font-size: 13px !important;

    span {
      font-family: var(--ph-font-family-lato-bold) !important;
    }
    &[disabled] {
      opacity: 0.1 !important;
      cursor: default !important;
      span {
        border: none !important;
      }
    }
  }
`
const RowWrapperStacked = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 45px;
  align-items: flex-start;
  color: var(--black);
  justify-content: center;
  padding-left: 25%;
  padding-right: 25%;
`;

const RowInput = styled('div')`
  display: flex;
  justify-content: center;

  [class*='SelectInputWrapper'] {
    [class*='help-block'] {
      margin-bottom: 0;
      margin-top: 5px;
      text-align: right;
    }
  }

  [class*='has-error'] {
    [class*='react-select__control'] {
      border-color: var(--ph-red-500) !important;
    }
  }
  
  [class*='InputWrapper'] {
    height: 55px;
    width: 280px;


    label {
      font-family: var(--ph-font-family-lato-bold);
      color: var(--dark-blue) !important;
      font-size: 11px !important;
    }

    input {
      border: 0.5px solid #0F1232;
      height: 28px;
    }

    [class*='help-block'] {
      line-height: 1.1 !important;
    }
    
    div[class*='react-select__control'] {
      height: 28px;
      min-height: 28px !important;
      border-color: var(--dark-blue);
    }
  }
`;

const PopupInvite = styled('div')`
  width: 400px;
`
const Container = styled('div')`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(128, 111, 102, 0.5);
  z-index: 9999;
`;

const ContainerInner = styled('div')`
  position: absolute;
  left: calc(50% - 200px);
  top: 12%;
  max-height: 77%;
  margin: auto;
  background-color: var(--white);
  padding: 20px;
  overflow-y: auto;
  width: 400px;
  box-shadow: 0px 3px 6px var(--ph-gray-15);
  opacity: 1;
`;

const Title = styled('div')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  line-height: 19px;
  color: var(--dark-blue);
  margin: 10px 36px;
`;

export default {
  Container,
  ContainerInner,
  ButtonWrapper,
  PopupInvite,
  RowWrapperStacked,
  RowInput,
  Title,
}